import React from "react";
// import CustomDropdown from "../components/CustomDropdown";
// import Button from "../components/Button";
// import { useAppContext } from "../context/appContext";
import { dropdownFormatter, extractDataFromArray, logoutCookies } from "../utils/utils&validatation";
import PageHeader from "../components/Header";
import { useNavigate } from "react-router-dom";
import { eventSlotListApi, isUserLoggedInApi, signOutApi } from "../apis/authService";
import Divider from "../components/Divider";
import Loader from "../components/Loader";
import useReloadOnBack from "./hooks/useReloadOnBack";
import CustomPopup from "../components/CustomPopup";
import { ArrowRight } from "lucide-react";

const EventSlots = () => {
    const navigate = useNavigate();
    // const { selected, setSelected } = useAppContext();

    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState(null);
    // const [dropdown, setDropdown] = React.useState([]);
    // const [disabled, setDisabled] = React.useState(true);
    const [isLoggedIn, setIsLoggedIn] = React.useState("checking");

    const handleLogout = React.useCallback(async () => {
        try {
            const res = await signOutApi({ cmd: "signOut" });
            if (extractDataFromArray(res, ["errorCode"], 1) == 0) {
                logoutCookies();
                navigate("/event-scanner/login");
            }
        } catch (err) {
            console.error("Error inside signOutApi =>", err)
        }
    }, [navigate]);

    // Check Login Status
    React.useEffect(() => {
        const verifyUser = async () => {
            try {
                const res = await isUserLoggedInApi({ cmd: "isUserLoggedIn" });
                if (extractDataFromArray(res, ["errorCode"]) === 0) {
                    window.user_info = extractDataFromArray(res, ["data"]);
                    setIsLoggedIn("logged-in");
                } else {
                    setIsLoggedIn("logged-out");
                }
            } catch {
                setIsLoggedIn("logged-out");
            }
        };
        verifyUser();
    }, []);

    // Auto-logout if needed
    React.useEffect(() => {
        if (isLoggedIn === "logged-out") handleLogout();
    }, [isLoggedIn, handleLogout]);

    // Fetch Events When Logged In
    React.useEffect(() => {
        const fetchEvents = async () => {
            try {
                const res = await eventSlotListApi({ cmd: "fetchOngoingEventsList" });
                setData(res?.data[0] || []);
            } catch (err) {
                console.log("Error fetching events:", err);
            }
        };
        if (isLoggedIn === "logged-in") fetchEvents();
    }, [isLoggedIn]);

    // const uniqueRecords = data?.records?.filter((value, index, self) =>
    //     index === self.findIndex((t) => (
    //         t.start_time === value.start_time &&
    //         t.end_time === value.end_time &&
    //         t.event_name === value.event_name
    //     ))
    // );

    // const sortedRecords = uniqueRecords?.sort((a, b) => {
    //     if (!a.start_time && !a.end_time) return 1;
    //     if (!b.start_time && !b.end_time) return -1;

    //     return new Date(a.start_time) - new Date(b.start_time);
    // });

    // const timePart = (str) => {
    //     const match = str.match(/\(([^()]*)\)\s*$/);
    //     return match ? match[1].trim() : "";
    // };


    // Process Dropdown Options
    // React.useEffect(() => {
    //     if (!data) return;

    //     if (sortedRecords.length === 1) {
    //         setSelected({
    //             event: sortedRecords[0].event_name,
    //             time: timePart(dropdownFormatter(sortedRecords[0])),
    //             start_time: sortedRecords[0].start_time,
    //             end_time: sortedRecords[0].end_time,
    //         })
    //     }

    //     setDropdown(
    //         sortedRecords.map(event => dropdownFormatter(event))
    //     );
    // }, [data]);

    // const handleSelect = (value) => {
    //     const selectedIndex = dropdown.findIndex(item => item === value);

    //     const selectedEvent = sortedRecords[selectedIndex];

    //     setSelected({
    //         event: selectedEvent.event_name === "" ? "NA" : selectedEvent.event_name,
    //         time: timePart(value),
    //         start_time: selectedEvent.start_time,
    //         end_time: selectedEvent.end_time,
    //     });
    // };

    // React.useEffect(() => {
    //     setDisabled(!(selected.event));
    // }, [selected]);

    // const handleSubmit = () => {
    //     navigate("/event-scanner/ticket-scanner");
    // };

    useReloadOnBack();

    return (
        <div className="flex h-full col-flex w-full">
            <PageHeader />
            <Divider />

            {data === null ? (
                <Loader />
            ) : data?.count?.length === 0 ? (
                <div
                    className="w-90 flex col-flex justify-center"
                    style={{ height: "70%", margin: "0 5%", gap: "16px" }}
                >
                    <img
                        src="https://qrcodechimp.s3.amazonaws.com/sysconf/no_event.svg"
                        alt="no_event.svg"
                        style={{
                            display: "block",
                            width: "65%",
                            margin: "0 auto",
                            height: "auto",
                        }}
                    />
                    <p
                        style={{
                            color: "#6a7282",
                            textAlign: "center",
                            fontSize: "20px",
                        }}
                    >
                        No event ticket found
                    </p>
                    <p
                        style={{
                            color: "#6a7282",
                            textAlign: "center",
                            fontSize: "20px",
                        }}
                    >
                        Create event ticket from <a href="/event-ticket-qr-code" target="_blank" rel="noopener noreferrer">QRCodeChimp Account</a>
                    </p>
                </div>
            ) : (
                <div
                    className="w-90 flex col-flex justify-center"
                    style={{ height: "70%", margin: "0 5%", gap: "16px" }}
                >
                    <p
                        style={{
                            color: "#6a7282",
                            textAlign: "center",
                            fontSize: "16px",
                        }}
                    >
                        Choose the event and time slot you want to manage
                    </p>

                    <div
                        className="br-8 p-12"
                        style={{
                            width: "auto",
                            display: "flex",
                            justifyContent: "space-between",
                            backgroundColor: "#f9fafb",
                            border: "2px solid #e2e8f0",
                            backgroundClip: "padding-box",
                            cursor: "pointer",
                        }}

                    // onMouseEnter={(e) => e.target.style.backgroundColor = "#f0f0f0"}
                    // onMouseLeave={(e) => e.target.style.backgroundColor = "#f9fafb"}
                    >
                        {/* <CustomDropdown
                            label="Event"
                            value={`${selected.event}${selected?.time && ` (${selected.time})`}`}
                            options={dropdown}
                            onChange={handleSelect}
                            placeholder="Choose event"
                        /> */}

                        {/* <Button
                            onClick={handleSubmit}
                            className="w-full font-sm mt-8"
                            buttonText="Proceed"
                            disabled={disabled}
                        /> */}
                        <b
                            onClick={() => setOpen(true)}
                            style={{
                                padding: "8px",
                                color: "#4d77fa",
                                width: "90%",
                                fontSize: "18px",
                            }}>
                            Click here to choose an event
                        </b>
                        <div
                            onClick={() => setOpen(true)}
                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                        ><ArrowRight width={30} height={30} color={"#6a7282"} /></div>
                        {
                            open &&
                            <CustomPopup
                                data={data}
                                onClose={() => setOpen(false)}
                            />
                        }
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventSlots;